import { icon } from '@carvana/ds-styles';
import { ClipboardCopy } from 'lucide-react';

export default function ShareToastContent() {
  return (
    <div className="flex w-auto items-center gap-md">
      <ClipboardCopy color={icon.strong} />
      <span className="text-text-strong t-strong-md">
        Link copied to clipboard
      </span>
    </div>
  );
}
